import { Theme, ThemeOptions } from '@mui/material';
import { getTypographyOverrides } from './typography';
import { getButtonOverrides } from './button';
import { getTextFieldOverrides } from './textField';

export const getOverrides = (theme: Theme): ThemeOptions['components'] => ({
  ...getTypographyOverrides(theme),
  ...getButtonOverrides(theme),
  ...getTextFieldOverrides(theme)
});